import React from "react";
import { LanguageCode, SurveyIntroduction } from "../../../../amorg-common";
import { Button } from "../../../../designSystem/button/Button";
import { ButtonRow } from "../../../../designSystem/button/ButtonRow";
import { H2 } from "../../../../designSystem/typography/Heading";
import { SurveyTxt } from "../../../../SurveyTxt";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { SECONDS_PER_QUESTION } from "./SurveyAnswerTypes";
import { IntroductionProgressPanel } from "./ProgressPanel";
import { SurveyOuterCard, SurveyInnerCard } from "./SurveyCard";
import { SurveyFactBox } from "./SurveyFactBox";


type SurveyIntroductionViewProps = {
    txt:SurveyTxt,
    selectedLanguage:LanguageCode,
    intro:SurveyIntroduction,
    defaultLanguage:LanguageCode,
    questionCount: number,
    hasSegmentations: boolean,
    onClickStart: () => void 
}
export function SurveyIntroductionView(props:SurveyIntroductionViewProps): JSX.Element {

    function getIntroText():string
    {
        if(props.selectedLanguage === props.defaultLanguage)
            return props.intro.text;
        else
            return props.intro.translations.find(t => t.languageCode === props.selectedLanguage)?.text || '';
    }

    const durationInMinutes = Math.ceil(props.questionCount * SECONDS_PER_QUESTION / 60);

    return (
        
        <Flex flexDirection="column">

            <IntroductionProgressPanel
                hasSegmentations={props.hasSegmentations}
                missingQuestionCount={props.questionCount}
                txt={props.txt}
            />

            <SurveyOuterCard>
                <Flex flexDirection="column" gap={32}>
                
                    <H2>{props.txt.introduction_header}</H2>
                
                    <SurveyInnerCard>
                        <span dangerouslySetInnerHTML={{ __html: getIntroText().replace(/\n/g, '<br />') }} />
                    </SurveyInnerCard>

                    <Flex gap={32}>
                        <SurveyFactBox
                            icon="clock"
                            header1={props.txt.introduction_factBoxTime_header1}
                            header2={props.txt.introduction_factBoxTime_header2(durationInMinutes)}
                            content={props.txt.introduction_factBoxTime_content(props.questionCount)}
                        /> 

                        <SurveyFactBox
                            icon="domino_mask"
                            header1={props.txt.introduction_factBoxMask_header1}
                            header2={props.txt.introduction_factBoxMask_header2}
                            content={props.txt.introduction_factBoxMask_content}
                        />
                    </Flex>

                    <ButtonRow>
                        <Button variant="filled" onClick={() => props.onClickStart()} text={props.txt.introduction_buttonStartText} />
                    </ButtonRow>
                    
                </Flex>
            </SurveyOuterCard>
        </Flex>
    );
}